import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ChoiceGroupTypeTable;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { choiceTypeObject } from '../../../../common/propTypes';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/es/format-message';
import ChoiceTypeTable from '../../shared/ChoiceTypeTable';
import BlankIcon from '../../../NewItemAnalysis/BlankIcon';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import ExpandableCard from '../../shared/ExpandableCard';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var ChoiceGroupTypeTable = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ChoiceGroupTypeTable = /*#__PURE__*/function (_Component) {
  function ChoiceGroupTypeTable() {
    var _this;
    _classCallCheck(this, ChoiceGroupTypeTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChoiceGroupTypeTable, [].concat(args));
    _defineProperty(_this, "state", {
      bodyExpanded: false
    });
    _defineProperty(_this, "getTranslatedBlankType", function (blank_type) {
      switch (blank_type) {
        case 'openEntry':
          return t('Open Entry');
        case 'wordbank':
          return t('Word Bank');
        case 'dropdown':
          return t('Dropdown');
        default:
          return blank_type;
      }
    });
    // Ideally this can happen only in case of openEntry
    _defineProperty(_this, "getTranslatedEmptyMessage", function () {
      return t('There are no entries for this open entry question.');
    });
    _defineProperty(_this, "renderBlankInfo", function () {
      var _blank$aggregate, _blank$aggregate2;
      var blank = _this.props.blank;
      var correctCount = (blank === null || blank === void 0 || (_blank$aggregate = blank.aggregate) === null || _blank$aggregate === void 0 ? void 0 : _blank$aggregate.correct) || 0;
      var incorrectCount = (blank === null || blank === void 0 || (_blank$aggregate2 = blank.aggregate) === null || _blank$aggregate2 === void 0 ? void 0 : _blank$aggregate2.incorrect) || 0;
      var noAnswer = (blank === null || blank === void 0 ? void 0 : blank.no_answer) || 0;
      var correctString = "".concat(t('Correct'), ": ").concat(correctCount, " ");
      var incorrectString = "".concat(t('Incorrect'), ": ").concat(incorrectCount, " ");
      var noAnswerString = "".concat(t('No Answer'), ": ").concat(noAnswer, " ");
      return jsx("div", {
        css: _this.props.styles.groupAggregationContainer
      }, jsx(Text, null, correctString), jsx(Text, null, incorrectString), jsx(Text, null, noAnswerString));
    });
    _defineProperty(_this, "renderTable", function () {
      var _this$props = _this.props,
        itemId = _this$props.itemId,
        blank = _this$props.blank,
        index = _this$props.index;
      var choices = blank.choices;
      var tableId = "".concat(itemId, "_").concat(index, "_choiceGroup");
      var tableContainerStyles = {};
      return jsx(ChoiceTypeTable, {
        itemId: tableId,
        choices: choices,
        tableContainerStyles: tableContainerStyles
      });
    });
    _defineProperty(_this, "renderBlankIcon", function () {
      var index = _this.props.index;
      var blankIconKey = "blank_icon_".concat(index);
      return jsx(BlankIcon, {
        key: blankIconKey,
        number: index + 1
      });
    });
    _defineProperty(_this, "renderHeadLine", function () {
      var blank = _this.props.blank;
      var blank_text = blank.blank_text,
        blank_type = blank.blank_type;
      var blankTextAndType = "".concat(blank_text, " (").concat(_this.getTranslatedBlankType(blank_type), ")");
      return jsx(Flex, {
        overflowY: "visible",
        direction: "row",
        alignItems: "start",
        wrap: "wrap"
      }, jsx(Flex.Item, null, _this.renderBlankIcon()), jsx(Flex.Item, {
        margin: "xxx-small medium small x-small"
      }, jsx(Text, {
        weight: "bold"
      }, blankTextAndType)), jsx(Flex.Item, {
        shouldShrink: true,
        margin: "xxx-small none small none"
      }, _this.renderBlankInfo()));
    });
    _defineProperty(_this, "renderEmptyInfo", function () {
      return jsx(Flex, {
        direction: "column",
        justifyItems: "start"
      }, jsx(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true,
        padding: "none none x-small none"
      }, jsx(Text, null, _this.getTranslatedEmptyMessage())));
    });
    _defineProperty(_this, "render", function () {
      var blank = _this.props.blank;
      var areThereChoices = Array.isArray(blank.choices) && blank.choices.length > 0;
      return jsx(ExpandableCard, {
        content: areThereChoices ? _this.renderTable() : _this.renderEmptyInfo(),
        headLine: _this.renderHeadLine()
      });
    });
    return _this;
  }
  _inherits(ChoiceGroupTypeTable, _Component);
  return _createClass(ChoiceGroupTypeTable);
}(Component), _defineProperty(_ChoiceGroupTypeTable, "displayName", 'ChoiceGroupTypeTable'), _defineProperty(_ChoiceGroupTypeTable, "componentId", "Quizzes".concat(_ChoiceGroupTypeTable.displayName)), _defineProperty(_ChoiceGroupTypeTable, "propTypes", {
  itemId: PropTypes.number.isRequired,
  blank: PropTypes.shape({
    choices: PropTypes.arrayOf(choiceTypeObject).isRequired,
    blank_text: PropTypes.string.isRequired,
    blank_type: PropTypes.string.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  styles: PropTypes.object
}.isRequired), _ChoiceGroupTypeTable)) || _class);